import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { blogs,articles } from "../../Components/BlogLogic/BlogLogic";
import { blog, blogInner } from "../../../../../images";
import Testimonial from "../Testimonials/Testimonial";

const BlogDetails = () => {
  const { id } = useParams();
  const blogD = blogs.find((b) => b.id === id);

  if (!blogD) return <p>Blog not found.</p>;
  useEffect(() => {
    // ✅ Select the static container
    const staticContainer = document.querySelector(".static-container");
    if (!staticContainer) return; // safeguard if not found

    // 🟢 Save old background before changing
    const oldBackground = staticContainer.style.backgroundImage;
    const oldBgColor = staticContainer.style.backgroundColor;
    const oldBgSize = staticContainer.style.backgroundSize;
    const oldBgRepeat = staticContainer.style.backgroundRepeat;
    const oldBgPosition = staticContainer.style.backgroundPosition;
    const oldBgAttachment = staticContainer.style.backgroundAttachment;

    // 🟣 Apply About Us background image
    staticContainer.style.backgroundImage = `url(${blogInner})`;
    staticContainer.style.backgroundSize = "cover";
    staticContainer.style.backgroundRepeat = "no-repeat";
    staticContainer.style.backgroundPosition = "center";
    staticContainer.style.backgroundAttachment = "fixed";
    staticContainer.style.transition = "background 0.5s ease-in-out";

    // 🔴 Cleanup: restore old background when leaving AboutUs
    return () => {
      staticContainer.style.backgroundImage = oldBackground;
      staticContainer.style.backgroundColor = oldBgColor;
      staticContainer.style.backgroundSize = oldBgSize;
      staticContainer.style.backgroundRepeat = oldBgRepeat;
      staticContainer.style.backgroundPosition = oldBgPosition;
      staticContainer.style.backgroundAttachment = oldBgAttachment;
    };
  }, []);
  return (
    <>
    {/* // <div className="blog-details-container container">
    //   <h2 className="blog-details-title">{blog.title}</h2>
    //   <p className="blog-details-subtitle">{blog.subtitle}</p>
    //   <div className="blog-details-image-div">
    //     <img src={blog.image} alt={blog.title} className="blog-details-image" />
    //   </div>
    //   <div className="blog-details-content">
    //     <p>{blog.content}</p>
    //     <p>{blog.content}</p>
    //     <p>{blog.content}</p>
    //     <p>{blog.content}</p>
    //     <p>{blog.content}</p>
    //     <p>{blog.content}</p>
    //   </div>
    // </div> */}
    <section className="chaos-section">
      <div className="chaos-container">
        {/* Left Section */}
        <div className="chaos-content">
          <div className="row align-items-center">
            <div className="col-12 col-md-8 col-lg-8">
              <h2 className="hero-heading gradient-text">
                From <span>Chaos</span> 
              </h2>
            <span className="hero-heading text-white"> to Clarity</span>
            <p className="hero-sub-text">
              Making Data Speak Your Brand’s Language
            </p>
            </div>
            <div className="col-12 col-md-4 col-lg-4">
              <div><img src={blog} alt="blog-inner" className="img-fluid"></img></div>
            </div>
          </div>
          <div className="row">
             <div className="col-12 col-md-12 col-lg-8">
             <dl className="chaos-body row">
               <dt className="hero-sub-text col-sm-3">Intro:</dt>
              <dd className="hero-sub-text col-sm-9">
              If you run an Amazon store, chances are
              your day begins and ends in a maze of dashboards, reports, and
              numbers.
            </dd>
              <dt className="hero-sub-text col-sm-3 mt-3">Body:</dt>
              <dd className="hero-sub-text col-sm-9 mt-3">
              The data’s there — but the meaning isn’t
              always clear. What if your analytics could talk back? What if
              every chart didn’t just show you what’s happening, but told you
              what to do next?
              <br />
              That’s where the clarity gap begins — and where Gapalzye steps in.
            </dd>
              <dt className="hero-sub-text col-sm-3 mt-3">Conclution:</dt>  
              <dd className="hero-sub-text col-sm-9 mt-3">
            <p className="hero-sub-text chaos-text">
              Most sellers rely on raw reports. But those reports don’t connect
              dots — they create confusion. <br />
              Your data speaks different languages: sales, ads, conversions,
              sessions — all shouting at once, none giving direction.
            </p>
            <p className="hero-sub-text chaos-text">
              Gapalzye bridges that gap. Our platform translates complex Amazon
              data into guided insights — simplified dashboards, KPI alerts, and
              visual storytelling that even non-analysts can understand.
            </p>
            <p className="hero-sub-text chaos-text">
              It’s not about replacing your intuition. It’s about giving your
              intuition the right context — so every decision you make is backed
              by clarity, not chaos.
            </p>
            </dd>
             </dl>
             </div>
<div className="col-12 col-md-12 col-lg-4 mt-5">
  {articles.map((blog, index) => (
    <div
      key={index}
      className="card blog-card border-0 text-white mb-4"
      style={{
        borderRadius: "15px",
        overflow: "hidden",
        maxWidth: "100%",
      }}
    >
      <div className="card-body p-0 d-flex flex-column flex-md-row gap-3">

        {/* IMAGE - always shows */}
        {blog.image && (
          <div
            className="rounded overflow-hidden card-blog-img"
          >
            <img
              src={blog.image}
              alt={blog.title}
              className="w-100 h-100"
              style={{ objectFit: "cover" }}
            />
          </div>
        )}

        {/* TEXT CONTENT */}
        <div className="flex-grow-1">
          <small className="text-light opacity-75 d-block mb-2 blog-date">
            {blog.date}
          </small>

          <h5 className="card-title fw-semibold text-white mb-2 blog-title">
            {blog.title}
          </h5>

          <p className="card-text text-secondary mb-0 blog-desc">
            {blog.desc}
          </p>
        </div>

      </div>
    </div>
  ))}
</div>


          </div>
         
        </div>
      </div>
    </section>
     {/* <div className="" style={{padding: "6rem 9rem"}}> */}
             <Testimonial />
             {/* </div> */}

        </>
  );
};

export default BlogDetails;
